import React, { useEffect, useRef } from 'react';

export default function CartRemovalDialog({ item, onCancel, onConfirm }) {
  const dialogRef = useRef(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    dialog.showModal();
    return () => dialog.close();
  }, []);

  return (
    <dialog ref={dialogRef} aria-labelledby="cart-removal-title" onCancel={onCancel} onClose={onCancel}
      onClick={event => { if (event.target === event.currentTarget) onCancel(); }}
      className="fixed inset-0 m-auto w-[calc(100%-32px)] max-w-md rounded-3xl border border-gray-100 bg-white p-0 text-gray-900 shadow-2xl backdrop:bg-black/50">
      <div className="p-6">
        <h3 id="cart-removal-title" className="text-xl font-semibold">Remove this item?</h3>
        <p className="mt-3 break-words text-sm text-gray-600">{item.displayTitle || item.title} will be removed from your cart.</p>
        <div className="mt-6 flex flex-wrap justify-end gap-3">
          <button type="button" autoFocus onClick={onCancel} className="rounded-full border border-gray-200 px-5 py-3 text-sm font-semibold">Keep item</button>
          <button type="button" onClick={onConfirm} className="rounded-full bg-red-600 px-5 py-3 text-sm font-semibold text-white">Remove item</button>
        </div>
      </div>
    </dialog>
  );
}
